module.exports = __webpack_public_path__ + "img/horizontal_3_1_pp1_8023.620b6a24.png";